import { Typography } from '@braskai/ui-kit';

import { getPercent } from '@/shared/lib/getPercent';

import { SBarContainer, SContainer, SContent, SHint, SProgress, SUsed } from './styled';

type UsageBarProps = {
  label: string;
  hint?: string;
  total: number;
  type?: 'min' | 'videos';
  used: number;
};

export const UsageBar = ({ label, hint, total, type, used }: UsageBarProps) => {
  return (
    <SContainer>
      <SContent>
        <Typography color="grey.900" variant="body-1-md">
          {label}
        </Typography>
        {type && (
          <SUsed color="grey.900" variant="body-2-md">
            {used} {type} used
            <Typography color="grey.500" variant="body-1-md">
              •
            </Typography>
            {total - used} {type} left
          </SUsed>
        )}
      </SContent>

      <SBarContainer>
        <SProgress value={getPercent(used, total)} />
      </SBarContainer>

      {hint && (
        <SHint color="grey.500" variant="caption-1">
          {hint} Unused minutes will roll over to the next month if you have an active subscription.
        </SHint>
      )}
    </SContainer>
  );
};
